/* SKAU Solutions – navigation (Produkter-menu): mus, klik, tastatur og touch */
(function () {
  'use strict';
  var items = document.querySelectorAll('[data-mega]');
  var hdr = document.querySelector('.hdr');
  var wide = function () { return window.matchMedia('(min-width: 900px)').matches; };
  var hover = function () { return window.matchMedia('(hover: hover)').matches; };

  [].forEach.call(items, function (item) {
    var btn = item.querySelector('.nav__btn');
    var timer = null;
    function open() { clearTimeout(timer); item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
    function close(refocus) {
      clearTimeout(timer); item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false');
      if (refocus) btn.focus();
    }
    btn.addEventListener('click', function () { item.classList.contains('is-open') ? close() : open(); });
    item.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' && wide() && hover()) open(); });
    item.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse' && wide() && hover()) { timer = setTimeout(close, 180); }
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && item.classList.contains('is-open')) { e.preventDefault(); close(true); }
    });
    item.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !item.contains(e.relatedTarget)) close();
    });
    document.addEventListener('click', function (e) { if (!item.contains(e.target)) close(); });
    item.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { close(); }); });
    window.addEventListener('resize', function () { close(); });
  });

  // Escape lukker også mobilmenuen
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && hdr && hdr.classList.contains('is-open')) {
      var b = hdr.querySelector('.burger');
      hdr.classList.remove('is-open'); if (b) { b.setAttribute('aria-expanded', 'false'); b.focus(); }
    }
  });

  // ?emne=demo vælger "Book en demo" i kontaktformularen
  try {
    var q = new URLSearchParams(location.search).get('emne');
    var sel = document.getElementById('c-topic');
    if (q && sel) {
      [].forEach.call(sel.options, function (o) { if (o.text.toLowerCase().indexOf(q.toLowerCase()) > -1) sel.value = o.value; });
    }
  } catch (e) {}
})();
